/**
 * 同步移动端真实可视区域 CSS 变量。
 * --vh: 1% 可视高度（基于 visualViewport）
 * --viewport-height: 可视区域高度（px）
 * --viewport-offset-top / --viewport-offset-bottom: fixed 元素相对 layout viewport 的偏移
 */

export function syncViewportCssVars() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  const visualViewport = window.visualViewport;
  const visibleHeight = visualViewport ? visualViewport.height : window.innerHeight;
  const offsetTop = visualViewport ? visualViewport.offsetTop : 0;
  const layoutHeight = window.innerHeight;
  const offsetBottom = Math.max(0, layoutHeight - visibleHeight - offsetTop);

  const root = document.documentElement;
  root.style.setProperty('--vh', `${visibleHeight * 0.01}px`);
  root.style.setProperty('--viewport-height', `${visibleHeight}px`);
  root.style.setProperty('--viewport-offset-top', `${offsetTop}px`);
  root.style.setProperty('--viewport-offset-bottom', `${offsetBottom}px`);
}

export function installViewportHeightSync() {
  syncViewportCssVars();

  const handler = () => syncViewportCssVars();
  window.addEventListener('resize', handler);
  window.addEventListener('orientationchange', handler);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', handler);
    window.visualViewport.addEventListener('scroll', handler);
  }

  return () => {
    window.removeEventListener('resize', handler);
    window.removeEventListener('orientationchange', handler);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', handler);
      window.visualViewport.removeEventListener('scroll', handler);
    }
  };
}

/** 全屏容器高度：优先动态 --vh，100dvh 作 progressive enhancement */
export const FULLSCREEN_HEIGHT_CSS = 'calc(var(--vh, 1vh) * 100)';
